import { render, staticRenderFns } from "./GridOffer.vue?vue&type=template&id=0f31d912&scoped=true"
import script from "./GridOffer.vue?vue&type=script&setup=true&lang=ts"
export * from "./GridOffer.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GridOffer.vue?vue&type=style&index=0&id=0f31d912&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f31d912",
  null
  
)

export default component.exports